import { IPaginatedTariff, IPagingTariff } from 'models/common-models';
import BaseService from '../base-service';
import StandardResponse from './../../models/standard-response';
import {
    IChargeStationList,
    IStationStatus,
    IStationTagList,
    IChargeLocationDetails,
    IChargeLocationList,
} from 'models/charge-station';
import { IChargeStationDetailsForPayByWebList } from 'models/charge-station';

export default class ChargeStationService {
    getChargeStations = async (data: any): Promise<StandardResponse<IChargeStationList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-locations/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IChargeStationList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getChargeStationStatus = async (): Promise<StandardResponse<IStationStatus[]>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-stations/status`,
                method: 'GET',
                data: { hideSpiner: false },
            });
            return new StandardResponse<IStationStatus[]>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getPayByWebChargeStation = async (data: any): Promise<StandardResponse<IChargeStationDetailsForPayByWebList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-stations/pay-by-web-search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IChargeStationDetailsForPayByWebList>(
                res.status,
                res.data.data,
                res.data.message,
                null,
            );
        } catch (e) {
            return Promise.reject(e);
        }
    };

    updatePayByWebChargeStation = async (
        id: Array<number>,
        pay_by_web_active: boolean,
    ): Promise<StandardResponse<IChargeStationDetailsForPayByWebList>> => {
        const data = {
            id,
            pay_by_web_active,
        };
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-stations/pay-by-web`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IChargeStationDetailsForPayByWebList>(
                res.status,
                res.data.data,
                res.data.message,
                null,
            );
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getTags = async (tag_type: string): Promise<StandardResponse<IStationTagList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/tags/search`,
                method: 'POST',
                data: {
                    tag_type,
                },
            });
            return new StandardResponse<IStationTagList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    addTagToChargeStation = async (data: any, id: string): Promise<any> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/${id}`,
                method: 'PUT',
                data,
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getLocationDetails = async (id: number): Promise<StandardResponse<IChargeLocationDetails>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/${id}`,
                method: 'GET',
            });
            return new StandardResponse<IChargeLocationDetails>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    importChargeStation = async (data: any): Promise<StandardResponse<Array<any>>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-locations/import-connector-powers`,
                method: 'POST',
                data,
            });
            return new StandardResponse<Array<any>>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    syncLocation = async (): Promise<StandardResponse<string>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-locations/location-sync`,
                method: 'GET',
            });
            return new StandardResponse<string>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getAssignedLocationsToTariff = async (tariffID, data: any): Promise<StandardResponse<IChargeLocationList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-tariffs/${tariffID}/assign-locations`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IChargeLocationList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    deleteAssignedChargeLocation = async (id: number, tariffID: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-tariffs/${tariffID}/assign-locations/${id}`,
                method: 'patch',
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    removeTariffFromLocations = async (tariffId: number, data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-tariffs/${tariffId}/remove-locations`,
                method: 'patch',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getChargeLocations = async (tariffID, data): Promise<StandardResponse<IChargeLocationList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-tariffs/${tariffID}/assign-locations`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IChargeStationList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    addChargeStationByTariffId = async (id: number, data: Array<any>): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-tariffs/${id}/assign-locations`,
                method: 'put',
                data: { assign: data },
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getChargeStationsForMap = async (): Promise<StandardResponse<IChargeStationList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-locations/map/search`,
                method: 'POST',
                data: {},
            });
            return new StandardResponse<IChargeStationList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    searchChargeStationsForMap = async (data): Promise<StandardResponse<IChargeStationList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-locations/map/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IChargeStationList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getChargeStationsDetails = async (id): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/map/${id}`,
                method: 'get',
            });
            return new StandardResponse<IChargeStationList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    addPromotionToChargeStation = async (data: any): Promise<any> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/reward-promotion/assign`,
                method: 'PUT',
                data,
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getChargeStationListForDownload = async (cpo_ids: Array<number> | null): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/export`,
                method: 'post',
                data: { cpo_ids },
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getAmenitiesList = async (id, data): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/${id}/site-amenities`,
                method: 'POST',
                data,
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updateAmenitiesForChargestation = async (id, data: Object): Promise<StandardResponse<boolean>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/${id}/site-amenities`,
                method: 'PUT',
                data,
            });
            return new StandardResponse<true>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updateGMBLocationID = async (id: number, data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-locations/update-details/${id}`,
                method: 'put',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getChargeLocationsCsvLink = async (cpo_ids: Array<number> | null): Promise<StandardResponse<string>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/extract-locations-data`,
                method: 'post',
                data: { cpo_ids },
            });
            return new StandardResponse<string>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    importStationsModel = async (data: any): Promise<StandardResponse<Array<any>>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-locations/import-stations-model`,
                method: 'POST',
                data,
            });
            return new StandardResponse<Array<any>>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    saveUniqueCode = async (id: number, data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-stations/${id}`,
                method: 'patch',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    addAllChargeStation = async (id: number, data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-tariffs/${id}/assign-all-locations`,
                method: 'PUT',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getTariffDetails = async (id: number): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/charge-locations/${id}/associated-tariffs`,
                method: 'GET',
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getOverrideTariffs = async (
        data: IPagingTariff,
        moduleName: string,
    ): Promise<StandardResponse<IPaginatedTariff>> => {
        try {
            const res = await BaseService({
                url: moduleName
                    ? `v1/admin/${moduleName}/assigned-tariffs/search`
                    : `/v1/admin/charge-tariffs/assignable-tariffs/search `,
                method: 'post',
                data: { ...data, hideSpiner: true },
            });
            return new StandardResponse<IPaginatedTariff>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
}
